<template>
  <div>
      <AssessorUpdateUI/>
  </div>
</template>

<script>
import AssessorUpdateUI from '../../../components/tax/TaxRollAdjustments/AssessorUpdate/AssessorUpdate.vue';

export default {
  name: 'AssessorUpdate',
  data: () => ({

  }),
  components: {
    AssessorUpdateUI,
  },
};
</script>
